import { gql } from 'apollo-boost';

export const GET_SPOTIFY_URI = gql`
    query getSpotifyUri($contentId: String!) {
        findagatewayMapping(id: $contentId)
    }
`;

// An acknowledgement, not an answer: `channel` is where the reply streams in.
// The old `message` field is always null now, so it is no longer requested.
export const CHAT_SEND_MESSAGE = gql`
    mutation chatSendMessage($message: String!, $conversationId: ID) {
        chatSendMessage(message: $message, conversationId: $conversationId) {
            conversationId
            channel
            error
        }
    }
`;
